import React from "react";
import {Badge} from "../../components/core/Badge.jsx";
import {Tag} from "../../components/core/Tag.jsx";
import {Icon} from "../../components/core/Icon.jsx";
import {Button} from "../../components/core/Button.jsx";
import {H2,Section,Eyebrow,Glitch,Reveal,Photo} from "./Shell.jsx";
import {CASES} from "../../content/casos.js";

function allTags(){
  const s=new Set();
  CASES.forEach(c=>(c.tags||[]).forEach(t=>s.add(t)));
  return Array.from(s);
}

export function CasesScreen({go}){
  const tags=allTags();
  const [active,setActive]=React.useState("Todos");
  const list=active==="Todos"?CASES:CASES.filter(c=>(c.tags||[]).includes(active));

  return <>
    <Section tone="card" style={{paddingTop:72}}>
      <div className="dp-split" style={{gap:"clamp(32px,5vw,64px)",alignItems:"center"}}>
        <Photo src="/assets/qr-scan-caja.jpg" alt="Escaneando con el móvil el código QR pegado en una caja del laboratorio" ratio="4 / 3"/>
        <div>
          <Eyebrow>Casos</Eyebrow>
          <h1 style={{fontSize:"clamp(32px,5.4vw,48px)",marginTop:18,maxWidth:"20ch"}}><Glitch>Trabajos terminados, con fotos, vídeo y 3D</Glitch></h1>
          <p style={{fontSize:"clamp(17px,2vw,20px)",lineHeight:1.45,color:"var(--fg-2)",marginTop:20,maxWidth:"48ch"}}>Cada caja que sale del laboratorio lleva un código QR junto al sello de Dental Project. Escanéalo con la cámara del móvil y llegas directo a la ficha de ese trabajo.</p>
          <div style={{display:"flex",alignItems:"center",gap:10,marginTop:28,color:"var(--fg-3)"}}>
            <Icon name="qr-code" size={18} strokeAlign="middle"/>
            <span style={{fontFamily:"var(--font-mono)",fontSize:12}}>Cámara del móvil → esta página</span>
          </div>
        </div>
      </div>
    </Section>

    <Section>
      {tags.length>0&&(
        <div style={{display:"flex",flexWrap:"wrap",gap:8,marginBottom:32}}>
          <Tag selected={active==="Todos"} onClick={()=>setActive("Todos")} style={{cursor:"pointer"}}>Todos</Tag>
          {tags.map(t=>(
            <Tag key={t} selected={active===t} onClick={()=>setActive(t)} style={{cursor:"pointer"}}>{t}</Tag>
          ))}
        </div>
      )}
      <div className="dp-g3" style={{gap:24}}>
        {list.map((c,n)=>{
          const cover=c.photos&&c.photos[0];
          return (
            <Reveal key={c.slug} delay={n*70}>
              <a href={`/casos/${c.slug}/`} onClick={e=>{e.preventDefault();go(`casos/${c.slug}`)}} style={{border:"none",display:"block"}}>
                <div style={{position:"relative"}}>
                  <Photo src={cover&&cover.src} alt={(cover&&cover.alt)||c.title} ratio="16 / 11" fit="contain"/>
                  {c.demo&&<Badge tone="warning" style={{position:"absolute",top:10,left:10}}>Ejemplo</Badge>}
                </div>
                <h4 style={{marginTop:14}}>{c.title}</h4>
                <div style={{fontFamily:"var(--font-mono)",fontSize:11,color:"var(--fg-3)",marginTop:4}}>{c.material}</div>
              </a>
            </Reveal>
          );
        })}
        {list.length===0&&<p style={{color:"var(--fg-3)"}}>Todavía no hay casos con esta etiqueta.</p>}
      </div>
    </Section>

    <Section tone="card">
      <div style={{border:"1px solid var(--line-ink)",borderRadius:"var(--radius-5)",padding:"clamp(32px,5vw,56px) clamp(24px,4vw,48px)",display:"flex",flexWrap:"wrap",alignItems:"center",justifyContent:"space-between",gap:"32px 40px"}}>
        <Reveal><h2 style={{fontSize:H2,maxWidth:"24ch"}}>¿Quieres un caso así? <Glitch>Envíamelo</Glitch>.</h2></Reveal>
        <Button size="lg" variant="accent" onClick={()=>go("contacto")} iconRight={<Icon name="arrow-right" size={16}/>}>Enviar un caso</Button>
      </div>
    </Section>
  </>;
}
